import { useState } from 'react';
import { Container, FormMessage, ViewButton, ViewText, ViewHelper, ViewTextInput } from './style';
import { emailValidator, removeSansSerif } from '../../../utils/validators';
import TextInput from '../../../components/TextInput';
import Button from '../../../components/Button';
import { HelperText } from 'react-native-paper';
import { SubTitle, SmallText } from '../../../config/theme/globalStyles';
import { SafeAreaView, Linking, TouchableOpacity, Text } from "react-native";
import THEME from '../../../config/theme';
import { getFunctions, httpsCallable } from "firebase/functions";
import { useCustomTheme } from '../../../contexts/useCustomTheme';

const functions = getFunctions();

export function ResetPassword({ isAdmin }) {
  const [email, setEmail] = useState({ value: '', error: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const { customColor, customFont } = useCustomTheme();

  const messageVariants = {
    hidden: { y: 30, opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { delay: 0.2, duration: 0.4 } },
  };

  const onResetPressed = async () => {
    const emailError = emailValidator(email.value);
    if (emailError) {
      setEmail({ ...email, error: emailError });
      return;
    }

    setLoading(true);
    try {
      const sendPasswordResetEmail = httpsCallable(functions, "sendPasswordResetEmail");
      const response = await sendPasswordResetEmail({ email: email.value.trim() });

      if (isAdmin && response.data?.code === 'user-not-found') {
        // No painel admin dizemos a verdade: mostrar "e-mail enviado" para um
        // e-mail fora da base gerava confusão no suporte. Para o ALUNO a
        // mensagem continua genérica (não revela se o e-mail existe).
        setError('Este e-mail não consta na base de alunos do app.');
      } else if (isAdmin && response.data?.resetLink) {
        setResult(response.data.resetLink);
      } else if (isAdmin && response.data?.error) {
        setError('Erro ao gerar o link de redefinição. Tente novamente.');
      } else {
        setResult('Enviamos um e-mail de recuperação de senha para este email.');
      }
    } catch (error) {
      console.error('Error sending password reset email:', error);
      setError('Erro ao enviar o e-mail de recuperação de senha. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };


  const handleLinkPress = () => {
    if (result) {
      Linking.openURL(result);
    }
  };

  return (
    <SafeAreaView>
      <Container>
        <SubTitle
          color="black"
          textAlign="left"
          margin="0rem 0rem 2rem 0rem"
          fontFamily={
            customFont && customFont.fontFamilyTitle
              ? removeSansSerif(customFont.fontFamilyTitle)
              : THEME.FONTFAMILY.REGULAR
          }
        >
          Redefina a sua senha:
        </SubTitle>
        <ViewTextInput>
          <ViewText>
            <TextInput
              label="Email"
              returnKeyType="next"
              value={email.value}
              onChangeText={text => setEmail({ value: text, error: '' })}
              error={!!email.error}
              autoCapitalize="none"
              autoCompleteType="email"
              textContentType="emailAddress"
              keyboardType="email-address"
              backgroundColor="white"
              colorPrimary={
                customColor &&
                  customColor.button &&
                  customColor.button.backgroundAuth
                  ? customColor.button.backgroundAuth
                  : THEME.COLORS.PRIMARY_900
              }
              colorOutline={
                customColor && customColor.primary
                  ? customColor.primary
                  : THEME.COLORS.PRIMARY_900
              }
              colorSurface={
                customColor && customColor.text && customColor.text.auth
                  ? customColor.text.auth
                  : THEME.COLORS.TITLE_ABOUT
              }
              fontFamily={
                customFont && customFont.fontFamilyText
                  ? removeSansSerif(customFont.fontFamilyText)
                  : THEME.FONTFAMILY.REGULAR
              }
            />
          </ViewText>
          <ViewHelper>
            <HelperText type="error" visible={email.error}>{email.error}</HelperText>
          </ViewHelper>
        </ViewTextInput>
        <ViewButton>
          <Button
            title={isAdmin ? 'Gerar link' : 'Enviar'}
            isLoading={loading}
            onPress={onResetPressed}
            style={{
              background:
                customColor &&
                  customColor.button &&
                  customColor.button.backgroundAuth
                  ? customColor.button.backgroundAuth
                  : THEME.COLORS.PRIMARY_900,
            }}
            colortitle={
              customColor && customColor.button && customColor.button.textAuth
                ? customColor.button.textAuth
                : THEME.COLORS.TEXT_BUTTON
            }
            fontFamily={
              customFont && customFont.fontFamilyText
                ? removeSansSerif(customFont.fontFamilyText)
                : THEME.FONTFAMILY.REGULAR
            }
          />
        </ViewButton>
        <ViewButton>
          {
            error && (
              <FormMessage
                variants={messageVariants}
                initial="hidden"
                animate="animate"
                error
              >
                {error}
              </FormMessage>
            )
          }
          {result &&
            (isAdmin ? (
              <>
                <SmallText margin="1rem 0rem">
                  Clique no link abaixo para redefinir:
                </SmallText>
                <TouchableOpacity onPress={handleLinkPress}>
                  <Text
                    style={{
                      color: 'blue',
                      textDecorationLine: 'underline',
                      alignSelf: 'center',
                    }}
                  >
                    {result}
                  </Text>
                </TouchableOpacity>
              </>
            ) : (
              <FormMessage
                variants={messageVariants}
                initial="hidden"
                animate="animate"
              >
                {result}
              </FormMessage>
            ))}
        </ViewButton>
      </Container>
    </SafeAreaView>
  );
}